module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('form', {
    staticClass: "login-form",
    attrs: {
      "action": ""
    },
    on: {
      "submit": _vm.modifyPhone
    }
  }, [_c('div', {
    staticClass: "big-tips"
  }, [_vm._v("\n            手机验证码发送至当前手机号:"), _c('br'), _c('label', {
    staticClass: "f-strongest"
  }, [_vm._v(_vm._s(_vm._f("dotted")(_vm.mobileNo)))])]), _vm._v(" "), _c('verify-code', {
    attrs: {
      "namespace": "ModifyPhone",
      "url": "/app/user/send",
      "param": _vm.param
    },
    model: {
      value: (_vm.verifyCode),
      callback: function($$v) {
        _vm.verifyCode = $$v
      },
      expression: "verifyCode"
    }
  }), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "0.75rem 0.5rem"
    }
  }, [_c('button', {
    staticClass: "btn-ok phone-click-next",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("下一步")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-285675a8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/profile/ModifyPhone.vue
// module id = 804
// module chunks = 0